// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__3P7Db","slide":"styles_slide__zgxEn","videoFrame":"styles_videoFrame__wIrPH"};